import { Api } from '../../core/api';
import { extendQueryString } from '../content/helpers';
import localStorage from '../../core/local-storage/localStorage';

const searchApi = new Api({
  initialData: null,
  namespace: 'SEARCH',
});

export const doSearch = ({
  locale,
  search,
  hash,
}: {
  search: string;
  locale?: string;
  hash?: string;
}) => {
  const additionalParams = {} as any;
  const adminParams = localStorage.get('admin-toolbar-settings');

  if (hash) {
    additionalParams.search = decodeURI(hash.split('#')[1] || '');
  }
  if (locale) {
    additionalParams.locale = locale;
  }
  if (adminParams) {
    additionalParams.adminParams = adminParams;
  }

  const searchString = extendQueryString(search, additionalParams);

  return searchApi.fetch({
    url: `/content/search${searchString}`,
  });
};

export const reducer = searchApi.reducer;
